// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"441131c2","296":"75fd95a6","450":"fa5a8f6e"}[chunkId] + ".chunk.js";
};